// extracted by mini-css-extract-plugin
module.exports = {"gratuity-wrapper":"yvtXpSYg1sWc-gWaIfQ-b","container-hyperlink":"_1lqFKFm7dG8qbkdvfo-KYj","checkout-setting-link":"_3bhx3VHB2wSpk-97qkTDyo"};